<template>
<div id="texosmotr">
    <h2 style="padding-bottom: 6px;">Заказать диагностическую карту</h2>
    <div class="col-md-120 no-padding">
        <div id="application" class="form2">
            <div class="col-lg-60 col-md-120 col-sm-120">
                <div class="field">
                    <input name="name"  type="text" placeholder="Фамилия Имя Отчество" v-model="user.name">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="email" v-model="user.email" type="email" placeholder="Email" title="Пример: example@mail.ru">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input type="tel" name="phone" v-model="user.phone" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" placeholder="Ваш номер телефона" >
                </div>
            </div>
            <div class="col-lg-60 col-md-120">
                <div class="field">
                    <input name="region"  type="text" v-model="user.district" placeholder="Область проживания">
                </div>
            </div>
            <div class="col-lg-60 col-md-120">
                <div class="field">
                    <select id="order-form-city" name="city"  v-model="citys" data-placeholder="Город проживания"></select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="vin"  class='cfvin' type="text" v-model="user.vin" placeholder="VIN">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="num_kuzov" class='cfvin' type="text" v-model="kuzov" placeholder="Номер кузова">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="num_shassi" class='cfvin' type="text" v-model="rama" placeholder="Номер шасси (рама)">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="year"  type="number" v-model="user.year" min="1900" max="2020" step="1" value="2019" placeholder="Год выпуска">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <select id="order-form-mark" data-placeholder="Марка" name="brand" v-model="user.mark" class="select2"></select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <select id="order-form-model" data-placeholder="Модель" name="model" v-model="user.model" disabled class="select2"></select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="probeg" type="number"  min="1" max="999999" v-model="probeg" step="1" placeholder="Пробег, км">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="number"  type="text" placeholder="Гос. номер" v-model="number">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="mark_shin"  type="text" placeholder="Марка шин" v-model="shini">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="massa_lite" type="text" placeholder="Масса без нагрузки, кг" v-model="massa_lite">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="massa" type="text" placeholder="Максимальная масса, кг" v-model="massa">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120 col-sm-120">
                <div class="field">
                    <select name="cat1"  class="select2" v-model="cat1" data-placeholder="Выберите категорию транспортного средства (СРТС или ПТС)">
                        <option selected>Выберите категорию транспортного средства (СРТС или ПТС)</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E (прицепы)">E (прицепы)</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120 col-sm-120">
                <div class="field">
                    <select name="fuel"  class="select2" v-model="fuel" data-placeholder="Выберите тип топлива">
                        <option selected>Выберите тип топлива</option>
                        <option value="Бензин">Бензин</option>
                        <option value="Дизель">Дизель</option>
                        <option value="Сжатый газ">Сжатый газ</option>
                        <option value="Сжиженный газ">Сжиженный газ</option>
                        <option value="Без топлива">Без топлива</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120 col-sm-120">
                <div class="field">
                    <select name="cat2"  class="select2" v-model="cat2" data-placeholder="Выберите категорию транспортного средства (ОКП)">
                        <option selected>Выберите категорию транспортного средства (ОКП)</option>
                        <option value="L">L</option>
                        <option value="M1 (пас., не более 8 пассажиров)">M1 (пас., не более 8 пассажиров)</option>
                        <option value="M2 (пас., не более 5 тонн)">M2 (пас., не более 5 тонн)</option>
                        <option value="M3 (пас., более 5 тонн)">M3 (пас., более 5 тонн)</option>
                        <option value="N1 (грузовые, менее 3,5 тонн)">N1 (грузовые, менее 3,5 тонн)</option>
                        <option value="N2 (грузовые, менее 12 тонн)">N2 (грузовые, менее 12 тонн)</option>
                        <option value="N3 (грузовые, более 12 тонн)">N3 (грузовые, более 12 тонн)</option>
                        <option value="O1 (прицепы, менее 0,75 тонн)">O1 (прицепы, менее 0,75 тонн)</option>
                        <option value="O2 (прицепы, менее 3,5 тонн)">O2 (прицепы, менее 3,5 тонн)</option>
                        <option value="O3 (прицепы, менее 10 тонн)">O3 (прицепы, менее 10 тонн)</option>
                        <option value="O4 (прицепы, более 10 тонн)">O4 (прицепы, более 10 тонн)</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120 col-sm-120">
                <div class="field">
                    <select name="tormoz"  class="select2" v-model="tormoz" data-placeholder="Выберите тип тормозной системы">
                        <option selected>Выберите тип тормозной системы</option>
                        <option value="Механическая">Механическая</option>
                        <option value="Гидравлическая">Гидравлическая</option>
                        <option value="Пневматическая">Пневматическая</option>
                        <option value="Комбинировання">Комбинировання</option>
                        <option value="Без тормозной системы">Без тормозной системы</option>
                        <option value="Незнаю тип">Незнаю тип</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120 col-sm-120">
                <div class="field">
                    <select name="doc"  class="select2" v-model="doc" data-placeholder="Выберите тип документа">
                        <option selected>Выберите тип документа</option>
                        <option value="Свидетельство ТС">Свидетельство ТС</option>
                        <option value="Паспорт ТС">Паспорт ТС</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="doc_ser"  type="text" placeholder="Серия" v-model="ser">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="doc_num"  type="text" placeholder="Номер" v-model="num">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="doc_date"  id="date" type="date" placeholder="Дата выдачи" v-model="date">
                </div>
            </div>
            <div class="col-lg-30 col-md-60 col-sm-120">
                <div class="field">
                    <input name="doc_give"  type="text" placeholder="Кем выдан" v-model="docg">
                </div>
            </div>
            <div class="col-lg-60 col-md-120">
                <div class="field">
                    <input name="sobstvennik" type="checkbox" value="Собственник иностранный гражданин" v-model="sobstv"> Собственник иностранный гражданин
                </div>
            </div>
            <div class="col-lg-60 col-md-120">
                <div class="field">
                    <input name="taxi" type="checkbox" value="Такси / Автобус" v-model="taxi"> Такси / Автобус
                </div>
            </div>
            <div class="get-offer">
                <button @click="sendTO">Отправить данные!</button>
            </div>
            <div class="error alert alert-danger" v-if="errors.length > 0">
                <p v-for="(error, index) in errors" :key="index">{{error}}</p>
            </div>
            <div class="agree">
                <label>
                    <input type="checkbox"  name="rules" v-model="check">
                    <span>Я соглашаюсь с <router-link to="/pol-zovatel-skoe-soglashenie/" target="_blank">условиями обработки персональных данных</router-link></span>
                </label>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
export default {
  name: 'texosmotr',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      errors: [],
      region: '',
      citys: this.$root.city.id,
      kuzov: '',
      rama: '',
      probeg: '',
      number: '',
      shini: '',
      massa_lite: '',
      massa: '',
      cat1: '',
      cat2: '',
      fuel: '',
      tormoz: '',
      doc: '',
      ser: '',
      num: '',
      date: '',
      docg: '',
      sobstv: '',
      taxi: '',
      check: 0,
      brands: [],
      marks: [],
      cityl: []
    }
  },
  mounted () {
    this.cityl[this.city.id] = this.city.name
    var $this = this
    $('.select2').select2()
    $('#order-form-city').select2({
      placeholder: 'Выберите город',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-cities',
        dataType: 'json',
        data: function (params) {
          params.lang = $this.$root.city.lang
          params.q = params.term
          return params
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.cityl[item.id] = item.text
              return {
                text: item.text,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.citys = $(this).val()
    })
    $('#order-form-mark').select2({
      placeholder: 'Выберите Марку',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-marks',
        dataType: 'json',
        processResults: function (data) {
          let res = $.map(data, function (item) {
            $this.brands[item.id] = item.name
            return {
              text: item.name,
              id: item.id
            }
          })
          return {
            results: res
          }
        }
      }
    }).change(function (data) {
      $this.user.mark = $(this).val()
      $('#order-form-model').val(null).trigger('change').prop('disabled', false)
    })

    $('#order-form-model').select2({
      placeholder: 'Выберите Модель',
      ajax: {
        delay: 250,
        type: 'POST',
        data: function (params) {
          params.brend_id = $this.user.mark
          params.q = params.term
          return params
        },
        url: 'https://crm.v-avtoservice.com/list/site-get-models',
        dataType: 'json',
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.marks[item.id] = item.name
              return {
                text: item.name,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.user.model = $(this).val()
    })
  },
  methods: {
    sendTO () {
      this.errors = []
      if (!this.user.name) this.errors.push('Вам необходимо заполнить ФИО')
      if (!this.user.email) this.errors.push('Вам необходимо указать email')
      if (!this.user.phone) this.errors.push('Вам необходимо указать телефон')
      if (!this.user.district) this.errors.push('Вам необходимо указать область проживания')
      if (!this.citys) this.errors.push('Вам необходимо указать город')
      if (!this.user.vin) this.errors.push('Вам необходимо указать VIN')
      if (!this.user.year) this.errors.push('Вам необходимо указать год выпуска')
      if (!this.user.mark) this.errors.push('Вам необходимо указать марку авто')
      if (!this.user.model) this.errors.push('Вам необходимо указать модель авто')
      if (!this.probeg) this.errors.push('Вам необходимо указать пробег')
      if (!this.number) this.errors.push('Вам необходимо указать гос номер')
      if (!this.shini) this.errors.push('Вам необходимо указать марку шин')
      /*
          if (!this.cat1) this.errors.push('Вам необходимо указать категорию ТС (ПТС)')
          if (!this.cat2) this.errors.push('Вам необходимо указать категорию ТС (ОКП)')
          if (!this.fuel) this.errors.push('Вам необходимо указать тип топлива')
          if (!this.tormoz) this.errors.push('Вам необходимо указать тип тормозной системы')
          if (!this.doc) this.errors.push('Вам необходимо указать тип документа')
      */
      if (!this.ser) this.errors.push('Вам необходимо указать серию документа')
      if (!this.num) this.errors.push('Вам необходимо указать номер документа')
      if (!this.date) this.errors.push('Вам необходимо указать дату выдачи документа')
      if (!this.docg) this.errors.push('Вам необходимо указать кем выдан документ')
      if (!this.check) this.errors.push('Вам необходимо принять условия обработки данных')
      if (this.errors.length === 0) {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        var notes = []
        if (this.user.name) notes.push('ФИО: ' + this.user.name)
        if (this.user.email) notes.push('E-mail: ' + this.user.email)
        if (this.user.phone) notes.push('Телефон: ' + this.user.phone)
        if (this.user.district) notes.push('Область проживания: ' + this.user.district)
        if (this.citys) notes.push('Город проживания: ' + this.cityl[this.citys])
        if (this.user.vin) notes.push('VIN: ' + this.user.vin)
        if (this.kuzov) notes.push('Номер кузова: ' + this.kuzov)
        if (this.rama) notes.push('Номер шасси (рама): ' + this.rama)
        if (this.user.year) notes.push('Год выпуска: ' + this.user.year)
        if (this.user.mark) notes.push('Марка авто: ' + this.brands[this.user.mark])
        if (this.user.model) notes.push('Модель авто: ' + this.marks[this.user.model])
        if (this.probeg) notes.push('Пробег, км: ' + this.probeg)
        if (this.number) notes.push('Гос. номер: ' + this.number)
        if (this.shini) notes.push('Марка шин: ' + this.shini)
        if (this.massa_lite) notes.push('Масса без нагрузки, кг: ' + this.massa_lite)
        if (this.massa) notes.push('Максимальная масса, кг: ' + this.massa)
        if (this.cat1) notes.push('Категория транспортного средства (СРТС или ПТС): ' + this.cat1)
        if (this.cat2) notes.push('Категорию транспортного средства (ОКП): ' + this.cat2)
        if (this.fuel) notes.push('Тип топлива: ' + this.fuel)
        if (this.tormoz) notes.push('Тип тормозной системы: ' + this.tormoz)
        if (this.doc) notes.push('Тип документа: ' + this.doc)
        if (this.ser) notes.push('Серия: ' + this.ser)
        if (this.num) notes.push('Номер: ' + this.num)
        if (this.date) notes.push('Дата выдачи: ' + this.date)
        if (this.docg) notes.push('Кем выдан: ' + this.docg)
        if (this.sobstv) notes.push('Собственник иностранный гражданин')
        if (this.taxi) notes.push('Такси / Автобус')
        formData.append('crm', '1')
        formData.append('pipe', '8')
        formData.append('contact[name]', this.user.name)
        formData.append('contact[3]', this.user.phone)
        formData.append('contact[4]', this.user.email)
        formData.append('contact[17]', this.user.district)
        formData.append('contact[45]', this.cityl[this.citys])
        formData.append('lead[5]', this.brands[this.user.mark])
        formData.append('lead[6]', this.marks[this.user.model])
        formData.append('lead[33]', this.user.year)
        formData.append('lead[34]', this.user.vin)
        formData.append('lead[69]', this.user.uid)
        formData.append('lead[23]', this.user.district)
        formData.append('lead[36]', this.cityl[this.citys])
        formData.append('lead[40]', 192)
        formData.append('note', notes.join('<br>'))
        axios.post('https://crm.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/texosmotr.vue